import React from 'react';
import { getPosition } from 'utils/DOMUtils';
import PropTypes from 'prop-types';

export default class StickyDiv extends React.Component {
  static propTypes = {
    offsetFromTop: PropTypes.number,
    stickyClass: PropTypes.string.isRequired,
    outerContainerClass: PropTypes.string,// eslint-disable-line
    children: PropTypes.node.isRequired,
    appclass: PropTypes.string,
    stickyFromTopStaticHeight: PropTypes.number,
    aboveFooter: PropTypes.bool,
    callbackProvided: PropTypes.func,
    msid: PropTypes.number,
    activeMsid: PropTypes.number,
    removeStickyOnArticleChange: PropTypes.bool,
    removeStickyClass: PropTypes.string,
    shouldRemoveSticky: PropTypes.bool,
    idSelectorInViewRemoveSticky: PropTypes.string,
  };
  static defaultProps = {
    offsetFromTop: 0,
    appclass: '',
    outerContainerClass: '',
    stickyFromTopStaticHeight: undefined,
    aboveFooter: false,
    callbackProvided: undefined,
    msid: undefined,
    activeMsid: undefined,
    removeStickyOnArticleChange: false,
    removeStickyClass: '',
    shouldRemoveSticky: undefined,
    idSelectorInViewRemoveSticky: undefined,
  };
  constructor(props) {
    super(props);
    this.state = { isSticky: false, removeStickyClassEnable: false };
    this.state.appview = false;
  }

  componentDidMount() {
    if (window.location.href.indexOf('frmapp') > 0) {
      this.setState({ appview: true });
    }
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false);
  }

  onScroll = () => {
    const callbackProvided = this.props.callbackProvided || (() => {});
    const offsetFromTop = this.props.offsetFromTop
      ? this.props.offsetFromTop
      : 0;
    const sticky =
      this.props.stickyFromTopStaticHeight ||
      getPosition(this.stickyDiv).y - parseInt(offsetFromTop, 10);
    const footerSelector = document.getElementById('toi-footer');
    const selectorInViewRemoveSticky = document.getElementById(
      this.props.idSelectorInViewRemoveSticky,
    );
    const selectorY = selectorInViewRemoveSticky
      ? getPosition(selectorInViewRemoveSticky).y
      : 0;
    const marginer =
      (window.innerHeight - this.stickyDivChild.offsetHeight) / 2;
    let _removeStickyClassEnable = false;
    if (
      selectorY > 0 &&
      window.pageYOffset + window.innerHeight > selectorY + marginer - 80
    ) {
      _removeStickyClassEnable = true;
    } else {
      _removeStickyClassEnable = false;
    }
    const isFooterVisible = !footerSelector
      ? false
      : window.pageYOffset +
          window.innerHeight * 0.95 -
          getPosition(footerSelector).y >
        0;
    const shouldSticky =
      window.pageYOffset >= sticky &&
      (!isFooterVisible || this.props.aboveFooter);
    if (shouldSticky && !this.state.isSticky) {
      callbackProvided({ sticky: true });
      //console.log('#####isSticky', true);
      this.setState({ isSticky: true });
    } else if (!shouldSticky && this.state.isSticky) {
      callbackProvided({ sticky: false });
      //console.log('#####isSticky', false);
      this.setState({ isSticky: false });
    } else if (
      this.state.isSticky &&
      _removeStickyClassEnable !== this.state.removeStickyClassEnable
    ) {
      this.setState({ removeStickyClassEnable: _removeStickyClassEnable });
    }
  };

  render() {
    let appClass = '';
    if (this.state.appview) {
      appClass = this.props.appclass;
    }
    let removeStickyClass = '';
    const stickyClass = this.props.stickyClass
      ? this.props.stickyClass
      : 'sticky';
    const { isSticky } = this.state;
    if (this.props.removeStickyOnArticleChange) {
      const { msid, activeMsid } = this.props;
      if (msid && activeMsid && msid !== activeMsid) {
        removeStickyClass = this.props.removeStickyClass;
      } else if (msid) {
        removeStickyClass = '';
      }
    }

    if (
      typeof this.props.shouldRemoveSticky === 'boolean' &&
      this.props.shouldRemoveSticky
    ) {
      removeStickyClass = this.props.removeStickyClass;
    }
    if (this.state.removeStickyClassEnable) {
      removeStickyClass = this.props.removeStickyClass;
    }
    return (
      <div
        className={`${
          this.props.outerContainerClass
        } ${appClass} ${removeStickyClass}`}
        ref={stickyDiv => {
          this.stickyDiv = stickyDiv;
        }}
      >
        <div
          ref={stickyDivChild => {
            this.stickyDivChild = stickyDivChild;
          }}
          className={isSticky ? stickyClass : ''}
        >
          {this.props.children}
        </div>
        <div />
      </div>
    );
  }
}
